
import { useState } from "react";
import { useQuery } from "@tanstack/react-query";
import { supabase } from "@/integrations/supabase/client";
import { UpdateLog } from "@/types/admin";

const ITEMS_PER_PAGE = 10;

export const useAdminLogs = () => {
  const [currentPage, setCurrentPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);
  
  const { data: logs = [], isLoading } = useQuery({
    queryKey: ["admin-logs", currentPage],
    queryFn: async () => {
      try {
        const { count, error: countError } = await supabase
          .from("report_update_logs" as any)
          .select("*", { count: "exact", head: true });
          
        if (countError) throw countError;
        
        if (count !== null) {
          setTotalPages(Math.ceil(count / ITEMS_PER_PAGE));
        }
        
        const { data, error } = await supabase
          .from("report_update_logs" as any)
          .select("*")
          .order("created_at", { ascending: false })
          .range((currentPage - 1) * ITEMS_PER_PAGE, currentPage * ITEMS_PER_PAGE - 1);
          
        if (error) throw error;
        
        return ((data || []) as unknown) as UpdateLog[];
      } catch (err) {
        console.error("Error fetching logs:", err);
        return [] as UpdateLog[];
      }
    },
  });
  
  const handlePageChange = (page: number) => {
    if (page >= 1 && page <= totalPages) {
      setCurrentPage(page);
    }
  };
  
  return {
    logs,
    isLoading,
    currentPage,
    totalPages,
    handlePageChange,
  };
};
